// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"85f01e2a","300":"16def007","307":"0ef8b1b6","660":"def15715","773":"b1e5c16c","971":"d4fdfecf"}[chunkId] + ".chunk.js";
};